export const computeChangeRatios = (prices: number[]): number[] => {
  if (!prices.length) return [];
  const first = prices[0];
  return prices.map((p) => (first ? (p - first) / first : 0));
};
